var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("keep-alive", [
    _c("div", { staticClass: "modal-mask" }, [
      _c("div", { staticClass: "modal-wrapper gnbSrch-wrap" }, [
        _c("div", { staticClass: "modal_size gnbSrch_size" }, [
          _c(
            "a",
            {
              staticClass: "ui_close",
              attrs: { href: "JavaScript:", type: "button" },
              on: {
                click: function($event) {
                  return _vm.$emit("close")
                }
              }
            },
            [_c("span", { staticClass: "sr_only" }, [_vm._v("popup close")])]
          ),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "ico_prev",
              attrs: { href: "JavaScript:", type: "button" },
              on: {
                click: function($event) {
                  return _vm.$emit("close")
                }
              }
            },
            [_c("span", { staticClass: "sr_only" }, [_vm._v("popup close")])]
          ),
          _vm._v(" "),
          _c("dl", { staticClass: "modal_content" }, [
            _c("dt", { staticClass: "ellipsis" }, [
              _c("i", [_vm._v(_vm._s(_vm.$t("FIELD.GLOBAL.SEARCH")))])
            ]),
            _vm._v(" "),
            _c(
              "dd",
              [
                _c(
                  "keep-alive",
                  [
                    _c("base-search-area", {
                      attrs: {
                        bToggle: true,
                        topClass: "gnbSrch_wrap",
                        callSearchFunc: _vm.callSearchFunc
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0fc9bed0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0fc9bed0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/skpComponents/view/basis/intgSearch/SearchEntryPopup.vue
// module id = uuCz
// module chunks = 0